export default __webpack_public_path__ + "static/lamp-01-f7b96f377b5f94a5cf4677c6c3f5582a.png";